import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var Currency = /*#__PURE__*/function () {
  function Currency(currencyCode, currencySymbol, precision) {
    _classCallCheck(this, Currency);

    if (!Currency._instance) {
      Currency.code = currencyCode;
      Currency.symbol = currencySymbol;
      Currency.precision = precision;
      Currency._instance = this;
    }

    return Currency._instance;
  }

  _createClass(Currency, null, [{
    key: "currencyCode",
    get: function get() {
      return this.code;
    }
  }, {
    key: "currencySymbol",
    get: function get() {
      return this.symbol;
    }
  }, {
    key: "currencyPrecision",
    get: function get() {
      return this.precision;
    }
  }]);

  return Currency;
}();

_defineProperty(Currency, "code", void 0);

_defineProperty(Currency, "symbol", void 0);

_defineProperty(Currency, "precision", void 0);

export default Currency;